exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-list {\n  display: flex;\n  flex-wrap: wrap;\n}\n.user-list .user-block {\n  flex: 0 48%;\n}", ""]);

// exports
